// FileDownload.tsx
import { toast } from "react-toastify";
import moment from "moment";
import SessionService from "../services/SessionService";
import { EXPORT_PRODUCTS_CSV_SEQUENCE, LEAGO_TO_PIM_FIELD_LIST } from "../utils/constants";

interface FileDownloadProps {
  requestInput: any;
  inputFileName: string;
  inputFileFormat: string;
  setLoading: (loading: boolean) => void;
}

const FileDownload = async ({ requestInput, inputFileName, inputFileFormat, setLoading }: FileDownloadProps) => {
  const sessionService = SessionService.getInstance();

  const downloadFile = async (response: Response, fileName: string) => {
    const date = moment();
    const formattedDate = date.format('YYYYMMDDHHMMSS');
    const blobData = await response.blob();
    const blobURL = window.URL.createObjectURL(blobData);

    const a = document.createElement('a');
    a.href = blobURL;
    a.style.display = 'none';
    a.download = `${fileName}_${formattedDate}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobURL);
  };

  const handleDownload = async () => {
    try {
      const sessionInfo = sessionService.getSessionToken();
      let url = '';

      switch (inputFileFormat) {
        case 'Quote Pricing Tooling':
          url = `${process.env.REACT_APP_API_URL}/quote/export-pricing-tooling`;
          break;
        case 'Quote List':
          url = `${process.env.REACT_APP_API_URL}/quote/export-quote-list-csv`;
          break;
        case 'Product Assignment List':
          url = `${process.env.REACT_APP_API_URL}/Assignment/product-assignment/export-csv`;
          break;
        case 'Design Report' :
        case 'Sampling Report' :
          url = `${process.env.REACT_APP_API_URL}/item/export-status-report`;
          break;
        case 'Toolings':
          url = `${process.env.REACT_APP_API_URL}/tooling/export`;
          break;
        case 'CVL Fields':
          url = `${process.env.REACT_APP_API_URL}/Picklist/export-cvls`;
          break;
        case LEAGO_TO_PIM_FIELD_LIST:
          url = `${process.env.REACT_APP_API_URL}/Picklist/leago-inriver-column-export`;
          break;
        case EXPORT_PRODUCTS_CSV_SEQUENCE:
          url = `${process.env.REACT_APP_API_URL}/Picklist/export-product-csv-fields-sequence`;
          break;
        default:
          throw new Error('Invalid download type');
      }

      setLoading(true);
      // Ensure the requestInput is an object
      let response;

      if (typeof requestInput !== 'object' || requestInput === null) {
        response = await fetch(url, {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionInfo,
          },
        });
      } else {
        response = await fetch(url, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionInfo,
          },
          body: JSON.stringify(requestInput),
        });
      }

      const contentType = response.headers.get("content-type");

      if (response.ok) {
        if (!contentType || response.status === 204) {
          // If no content type or 204 status, it means no records found
          toast.error('No records found for the selected criteria');
        } else if (contentType && contentType.includes('application/json')) {
          const bodyResp = await response.json();
          toast.error(bodyResp.message);
        } else if (contentType && (contentType.includes('text/csv') || 
                                    contentType.includes('application/zip') || 
                                    contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'))) {
          await downloadFile(response, inputFileName);
          toast.success(`${inputFileFormat} Exported Successfully`);
        }
      } else if (response.status === 404 || response.status === 204) {
          toast.error("No records found for the selected criteria");
      } else {
        toast.error('Error while downloading file');
      }
    } catch (error) {
      console.error('Error while downloading file:', error);
      toast.error('Error while downloading file');
    } finally {
      setLoading(false);
    }
  };

  return {
    handleDownload,
  };
};

export default FileDownload;